import React, { FC, useEffect, useRef, useState } from 'react';
import { WhisperComponent } from './developers/page-components/WhisperComponent';

interface Props {
  text: string;
}
export const OverflowTooltip: FC<Props> = ({ text }) => {
  const textRef = useRef(null);
  const [width, setWidth] = useState(0);

  useEffect(() => {
    if (textRef.current) {
      setWidth(textRef.current.offsetWidth);
    }
  }, [text]);

  return (
    <>
      {
        textRef?.current?.scrollWidth > width
          ? <WhisperComponent
            isTooltip
            whisperText={text}
            mainText={
            <div
              className="text-truncate"
              ref={textRef}
              data-cy="text-truncate"
            >
              {text}
            </div>
          }
          />
          : <div className="fc-text-overflow" ref={textRef} data-cy="text-without-truncate">{text}</div>
      }
    </>
  );
};
